export { default as TableHomeProducts } from './TableHomeProducts';
export { default as TableHomeJournalisation } from './TableHomeJournalisation';



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Home/tables/index.js